import {useEffect, useState} from 'react';
import usePrevious from './usePrevious';
import useUserAgent from './useUserAgent';
import {VideoSource} from '../type';

export default function useValidVideoSources(originSources?: VideoSource[]) {
  const [sources, setSources] = useState<VideoSource[] | undefined>(() =>
    getValidSources(originSources)
  );
  const userAgent = useUserAgent();

  const prevOriginSources = usePrevious(originSources);
  useEffect(() => {
    if (
      userAgent &&
      (sources === undefined || prevOriginSources !== originSources)
    ) {
      const {isIos, isMacOs, isSafari} = userAgent;
      canUseWebm = !isIos && !(isMacOs && isSafari);
      setSources(getValidSources(originSources));
    }
  }, [originSources, prevOriginSources, userAgent, sources]);

  return sources;
}

let canUseWebm: boolean | undefined;
function getValidSources(originSources?: VideoSource[]) {
  if (canUseWebm === undefined) {
    return undefined;
  } else if (canUseWebm) {
    return originSources;
  } else {
    return originSources?.filter(({type}) => type !== 'video/webm');
  }
}
